module.exports = __webpack_public_path__ + "img/facebook.47a6f0fd.svg";